import React from 'react';
import { ICON_MAP } from './iconMapper';
import { BUTTON_STYLE_MAP } from './buttonConfig';
import './GlobalButton.css';

const GlobalButton = ({
  type,
  label,
  icon,
  onClick,
  active = false,
  size = 'md', // sm | md
  disabled = false,
  iconLast = false,
  hideIcon,
  loading = false,
}) => {
  const IconEl = loading ? ICON_MAP['loading'] : icon || ICON_MAP[type];
  const styles = BUTTON_STYLE_MAP[type] || {};

  return (
    // <button
    //   className={`global-btn ${size} ${active ? 'active' : ''}`}
    //   style={{
    //     backgroundColor: active ? styles.activeBg || styles.bg : styles.bg,
    //     color: active ? styles.activeColor || styles.color : styles.color,
    //     border: styles.border || 'transparent',
    //     minWidth: styles.minWidth || 'auto',
    //   }}
    //   onClick={onClick}
    //   disabled={disabled}
    // >

    <button
      className={`global-btn ${size} ${active ? 'active' : ''}`}
      style={{
        '--btn-bg': active ? styles.activeBg || styles.bg : styles.bg,
        '--btn-color': active ? styles.activeColor || styles.color : styles.color,
        '--btn-border': styles.border || 'transparent',
        minWidth: styles.minWidth || 'auto',
      }}
      onClick={onClick}
      disabled={disabled}
    >
      {iconLast && label && IconEl ? (
        <>
          <span className="btn-label">{label}</span>
          {!hideIcon && <span className="btn-icon">{IconEl}</span>}
        </>
      ) : (
        <>
          {!hideIcon && <span className="btn-icon">{IconEl}</span>}
          <span className="btn-label">{label}</span>
        </>
      )}
    </button>
  );
};

export default GlobalButton;
